import * as React from 'react';
import { FunctionComponent } from 'react';

// Custom components
import SidebarProvider from '@/context/SidebarContext/SidebarProvider';
import SidebarRoot from './SidebarRoot';

import { positionType } from '@/context/SidebarContext/SidebarContext';

// Types
export interface ISidebarControl {
  initialOpenId?: string;
  initialOpenHeading?: string;
  onTabChange?: (id: string) => void;
  onSidebarCollapse?: (newState: boolean) => void; // Function to handle sidebar collapse
  id?: any;
  position?: positionType;
  children: JSX.Element | JSX.Element[];
  isHidden?: boolean;
}

const SidebarControl: FunctionComponent<ISidebarControl> = (props) => {
  const { id, initialOpenId, position, onTabChange, children, initialOpenHeading, onSidebarCollapse, isHidden} = props;

  return (
    <SidebarProvider
      sidebarId={id}
      initialOpenId={initialOpenId}
      onTabChange={onTabChange}
      initialOpenHeading={initialOpenHeading}
      positionProp={position}
      onSidebarCollapse={onSidebarCollapse}
      isHidden={isHidden}
    >
      <SidebarRoot id={id} initialOpenId={initialOpenId} initialOpenHeading={initialOpenHeading} position={position}>
        {children}
      </SidebarRoot>
    </SidebarProvider>
  );
};

export default SidebarControl;
